
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
             <CCardHeader>
              <CIcon name="cil-grid"/> 学習用テキスト
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                    <CButton size="sm" color="info" @click="showRecordModal({}, 0, 'new')">新規作成</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="10">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="業種"
                    :options="industryTypes"
                    v-model="select_industry"
                    @update:value="search"
                    name="industry_id"
                  />
                </CCol>
              </CRow>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="learning_text"
                :fields="fields"
                :loading="isLoading"
                :itemsPerPage="20"
                :responsive="true"
                :tableFilter="true"
                @update:table-filter-value="search"
                sorter
                @update:sorter-value="sort"
              >
                <template #industry_id="{item}">
                  <td> {{ industries[item.industry_id] }}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

              </CDataTable>
              <CPagination
                :activePage.sync="page"
                :pages="meta.total_pages"
                align="center"
                @update:activePage="updatePageData"
              />
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">業種</label>
           <CSelect
             placeholder="業種を選択してください"
             :class="{ 'hasError': $v.record.industry_id.$error }"
             :options="industryTypes"
             :value.sync="record.industry_id"
           />

           <small v-if="$v.record.industry_id.$error" class="errorLabel">業種を選択してください</small>
         </CCol>


         <CCol sm="12">
           <label class="record-label pt-3">小業種</label>
           <CInput v-model="record.small_industry" />
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">タイトル</label>
           <CInput placeholder="タイトル" v-model="record.title" :class="{ 'hasError': $v.record.title.$error }"/>
           <small v-if="$v.record.title.$error" class="errorLabel">タイトルを入力してください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">URL</label>
           <CInput placeholder="" v-model="record.link" :class="{ 'hasError': $v.record.link.$error }"/>
           <small v-if="$v.record.link.$error" class="errorLabel">URLを入力してください</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem()">登録</CButton>
       </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required , url} from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isLoading: true,
      select_industry: '',
      filter_cs: [],
      filter_vs: [],
      select_place: "",
      select_type: "",
      word: "",
      page: 1,
      industries: {},
      modalType: 'new',
      sort_column: "id",
      sort_asc: "desc",
      learning_text: {},
      meta: {},
      recordModal: false,
      deleteModal: false,
      fields: [
        { key: 'industry_id', label: "業種"},
        { key: 'small_industry', label: "小業種"},
        { key: 'title', label: "テキスト名"},
        { key: 'link', label: "リンク"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}
      ],
      record: {},
      industryTypes: []
    }
  },
  validations: {
    record: {
      title: {required},
      industry_id: {required},
      link: {required, url}
    }
  },
  methods: {
    showRecordModal(item, index, type="edit"){
      this.modalType = type
      this.recordModal = true
      this.record = item
      this.itemIndex = index
    },
    modalModeCss: function() {
      return (this.mode == "new")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "new")? "新規作成" : "編集"
    },
    dumyData(text){
      this.isData = true
      return text
    },
    checkText(text){
      if(text != ''){
        if(text != this.beforeText){
          this.beforeText = text
          return 'first'
        }else{
          return 'second'
        }
      }else{
        return 'normal'
      }
    },
    getPlace(ids){
      var idList = ids.split(',')
      var result = ''
      idList.forEach(id =>{
        if(id != '') {
          result += this.dictPlaces[id]['name'] + ' , '
        }
      })
      return result.slice( 0, -2 )
    },
    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/learning_text?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&per_page=20", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.learning_text = response.data.learning_text
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/learning_texts?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=20", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.learning_text = response.data.learning_text
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = e
      if(c != undefined){
        this.filter_update(c.target.name, e)
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/learning_texts?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=20", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.learning_text = response.data.learning_texts
          this.meta = response.data.meta
          console.log(response.data)
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
      var dat = moment(d)
      if(dat.isValid()) {
        return moment(d).tz('Asia/Tokyo').format("YYYY年MM月DD日 HH:mm")
      } else {
        return d
      }
    },

    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/learning_texts?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") +"&page=" + n + "&word=" + this.word + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=20", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.learning_text = response.data.learning_texts
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/learning_texts/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.learning_text.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    updateItem(){
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log("error")
      } else {
        if(this.modalType == 'new'){
          axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/learning_texts", {learning_text: this.record} ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.learning_text.push(this.record)
            this.meta.total_pages = response.data.total_page
            this.recordModal = false
          }).catch(error => {
            this.errorNotify(error.response)
          })
        } else {
          axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/learning_texts/" + this.record.id, {learning_text: this.record} ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            console.log(response)
          }).catch(error => {
            this.errorNotify(error.response)
          })
        }
      }
    }
  },
  mounted() {
    axios
    .get(process.env.VUE_APP_API_ENDPOINT + "/learning_texts?per_page=20&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response)
          this.learning_text = response.data.learning_texts
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })

      axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industries[0] = ''
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
          })
          this.industries = Object.assign({}, this.industries)

          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
          this.isLoading = false
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
  watch: {
    '$route': function () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>

<style scoped lang="scss">
.answer-form {
  padding: 5px 0px;
}

</style>

